import type { Order } from "../../domain/entities/Order";
import type { OrderId } from "../../domain/value-objects/OrderId";
import type { OrderQueryPort } from "../ports/OrderQueryPort";

export class ApplyOrderCouponUseCase {
  constructor(private readonly orders: OrderQueryPort) {}

  execute(orderId: OrderId, code: string): Promise<Order> {
    const normalized = code.trim().toUpperCase();
    if (!normalized) return Promise.reject(new Error("Ingresa un código promocional"));
    return this.orders.applyCoupon(orderId, normalized);
  }
}

export class RemoveOrderCouponUseCase {
  constructor(private readonly orders: OrderQueryPort) {}

  execute(orderId: OrderId): Promise<Order> {
    return this.orders.removeCoupon(orderId);
  }
}
